module.exports = __webpack_public_path__ + "assets/img/a1f5d2e74b68c0edf8334079d0cf534d.png";